module.exports = __webpack_public_path__ + "static/66a163f4a20e9a30228d1f73e694b1e85dee718000ee8a3f25fecb87a855409e-fb494bebc17c15d52b5230de7abc203d.png";